import {
    FETCH_MASTER_DATA_REQUEST,
    FETCH_MASTER_DATA_SUCCESS,
    FETCH_MASTER_DATA_FAILURE,
  } from './masterDataTypes'
const initialState = {
    loading: false,
    masterData:'',
    // selectedQuestionList: null,
    error: '',
  }
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case   FETCH_MASTER_DATA_REQUEST:
        return {
          ...state,
          loading: true
        }
      case FETCH_MASTER_DATA_SUCCESS:
        return {
          ...state,
          loading: false,
          masterData: action.payload,
          error: ''
        }
      case FETCH_MASTER_DATA_FAILURE:
        return {
          ...state,
          loading: false,
          masterData: [],
          error: action.payload
        }
       
      default: return state
    }
  }
  
  export default reducer
  